import { useEffect, useState, useRef } from "react";
import axios from "axios";

function drawTypedSignature(printName, signatureFont, onChange, canvasRef) {
if (!canvasRef?.current) return;

const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");

  // clear
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // apply font
  ctx.font = `48px "${signatureFont || "Great Vibes"}", cursive`;
  ctx.fillStyle = "#000000";

  // center text
  const textMetrics = ctx.measureText(printName || '');
  const x = (canvas.width - textMetrics.width) / 2;
  const y = canvas.height / 2 + 16;

  ctx.fillText(printName || '', x, y);

  const dataUrl = canvas.toDataURL("image/png");

  if (onChange) onChange(dataUrl); // update react-hook-form value
  return dataUrl;
}

function clearCanvasAndChange(onChange, canvasRef) {
  return () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    onChange("");
  };
}


function useWarmup(url, cooldownMinutes = 10) {
  const lastWarmup = useRef(null);

  useEffect(() => {
    const now = Date.now();
    const shouldWarmUp = !lastWarmup.current || (now - lastWarmup.current > cooldownMinutes * 60 * 1000);

    if (shouldWarmUp) {
      let attempts = 0;
      const maxAttempts = 3;

      const wake = async () => {
        while (attempts < maxAttempts) {
          try {
            await axios.post(url, { warmup: true }, { timeout: 8000 });
            console.log(`✅ Warmed up: ${url}`);
            lastWarmup.current = Date.now();
            break;
          } catch (err) {
            attempts++;
            console.warn(`⚠️ Warmup attempt ${attempts} failed:`, err.message);
            if (attempts < maxAttempts) await new Promise(res => setTimeout(res, 1000));
          }
        }
        if (attempts >= maxAttempts) {
          console.error(`❌ Failed to warm up ${url} after ${maxAttempts} attempts`);
        }
      };

      wake();
    }
  }, [url]);
};

// need a function to grab file from blob in Azure in order to access blob contents
async function getBlobFileContent(blobUrl) {
  const response = await fetch(blobUrl);
  if (!response.ok) throw new Error('Failed to fetch blob content');
  return await response.text();
}

const UpdateToast = () => {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setWaitingWorker(e.detail.waiting || e.detail.installing || e.detail);
      setShowReload(true);
    };

    window.addEventListener("swUpdated", handler);
    return () => window.removeEventListener("swUpdated", handler);
  }, []);

  const reloadPage = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
      waitingWorker.addEventListener("statechange", (e) => {
        if (e.target.state === "activated") {
          window.location.reload();
        }
      });
    }
  };

  if (!showReload) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        background: "#263395",
        color: "white",
        padding: "1rem",
        borderRadius: "6px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 9999,
      }}
    >
      <p style={{ margin: 0 }}>⚡ A new version is available!</p>
      <button
        onClick={reloadPage}
        style={{
          marginTop: "0.5rem",
          background: "white",
          color: "#263395",
          border: "none",
          borderRadius: "4px",
          padding: "0.4rem 0.8rem",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Refresh
      </button>
    </div>
  );
};



export { drawTypedSignature, clearCanvasAndChange, getBlobFileContent, UpdateToast, useWarmup };